/* src/app/components/containers/workflow-center/workflow-center.component.css */
thead th {
  border-bottom: 2px solid #e5eaed !important;
  white-space: nowrap;
  padding: 10px 10px 10px 0;
  position: relative;
}
thead th p {
  font-family: "robotomedium";
  font-size: 20px;
  color: black;
  margin-left: 45px;
  margin-right: 45px;
  margin-top: 10px;
}
tbody td {
  border: 2px solid #e5eaed !important;
}
.task-opened {
  font-weight: normal;
}
.task-unread {
  font-weight: bold;
}
.task-file {
  cursor: pointer;
  text-decoration: underline;
  color: #1589FF;
}
.task-paging p {
  cursor: pointer;
}
.popuptask .description a,
.popuptask .description a:visited {
  color: #0000EE !important;
  text-decoration: underline !important;
}
.task-table p {
  font-family: "asapmedium" !important;
  color: black !important;
}
/*# sourceMappingURL=workflow-center.component.css.map */
